module.exports = __webpack_public_path__ + "img/investec-travel-logo.139641b9.png";